"use client";

import { ArrowUp, Facebook, Linkedin, Twitter } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuContent() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-2">
        <div className="h-4 w-24 bg-muted animate-pulse rounded-md" />
        <div className="h-4 w-20 bg-muted animate-pulse rounded-md" />
      </div>;
  }
  return <nav className="flex flex-col gap-3">
      {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="text-sm hover:text-secondary transition-colors">
          {item.label}
        </Link>)}
    </nav>;
}
function FooterMenuWrapper() {
  return <MenuProvider menu_id="footer_menu">
      <FooterMenuContent />
    </MenuProvider>;
}
export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  const socialLinks = [{
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }];
  return <section data-section-id="264699" id="footer" className="bg-background text-foreground border-t border-border">
      {}
      <div className="mx-auto max-w-7xl px-4 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          {}
          <div className="flex flex-col gap-4">
            <Link to="/" className="inline-flex">
              <WvcLogo className="h-8 w-auto text-primary" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed font-default">
              Transformando aceite de cocina usado y biomasa en biodiésel limpio y renovable para impulsar el futuro sostenible de Cuba.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="font-bold tracking-tight">
              Recursos Educativos
            </h3>
            <FooterMenuWrapper />
            <Link to="#" className="text-sm hover:text-secondary transition-colors">
              Cursos sobre la elaboración del Biodiesel
            </Link>
          </div>

          <div className="flex flex-col gap-4">
            <h3 className="font-bold tracking-tight">
              Videos
            </h3>
            <Link to="https://youtu.be/l9dS5piHNr8?si=70KokPQX8n5tPGX0" className="text-sm hover:text-secondary transition-colors">Videos</Link>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="font-bold tracking-tight">Empresa</h3>
            <nav className="flex flex-col gap-3">
              <Link to="/HomePage" className="text-sm hover:text-secondary transition-colors">Nuestra Mision</Link>
              <Link to="#" className="text-sm hover:text-secondary transition-colors">Proceso de Produccion</Link>
              <Link to="#" className="text-sm hover:text-secondary transition-colors">Impacto CO2</Link>
            </nav>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="font-bold tracking-tight">
              Contact
            </h3>
            <div className="flex flex-col gap-2 text-sm text-muted-foreground">
              <p className="font-default">BioPower SRL Office, Havana, Cuba</p>
              <Link to="tel:+5371234567" className="text-sm hover:text-secondary transition-colors">+53 53 31 9829</Link>
              <Link to="mailto:info@biopower.cu" className="text-sm hover:text-secondary transition-colors">biopowercuba@gmail.com</Link>
            </div>
            <div className="flex gap-3 pt-2">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} data-index={i} to={social.href} className="w-9 h-9 rounded-lg border border-border hover:border-secondary hover:bg-secondary/10 flex items-center justify-center text-foreground transition-all shadow-sm" aria-label={social.label}>
                    <Icon className="w-4 h-4" />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        {}
        <div className="flex justify-end mb-8">
          <Button onClick={scrollToTop} variant="ghost" size="icon" className="border border-border hover:bg-accent rounded-lg shadow-sm transition-all" aria-label="Back to top">
            <ArrowUp className="w-4 h-4" />
          </Button>
        </div>
      </div>

      {}
      <Separator className="bg-border/50" />
      <div className="mx-auto max-w-7xl px-4 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground">
          <p className="font-default">
            &copy; 2024 BioPower SRL. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="#" className="text-sm hover:text-secondary transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="text-sm hover:text-secondary transition-colors">
              Terms of Service
            </Link>
            <Link to="#" className="text-sm hover:text-secondary transition-colors">
              Cookie Settings
            </Link>
          </div>
        </div>
      </div>
    </section>;
}